import type { AppState } from 'src/reducers';
import { createSelector } from 'reselect';
import {
  projectState,
  StateSelection,
  createFilteredViewDefnsSelector,
} from 'src/components/MacroGridPair/MacroGridPair.selectors';
import { getUniqueDataFromCache, HashType, isDataLoaded } from 'src/services/pivotServiceCache';
import type { ProductDetailsOwnProps } from 'configuration-schemas/ownProps';

const getRawViewDefns = (state: AppState) => state.pages.hindsighting.aggregateViews.productDetails.viewDefns;
const getFilteredViewDefns = createFilteredViewDefnsSelector(getRawViewDefns);

function selectState(state: AppState, ownProps: ProductDetailsOwnProps): StateSelection {
  const { title } = ownProps;
  const { productDetails: viewState } = state.pages.hindsighting.aggregateViews;
  const { macroDataState, gridDataState } = viewState;
  const viewDefns = getFilteredViewDefns(state);
  const macroData = getUniqueDataFromCache(viewState, HashType.macro)?.tree || [];
  const gridData = getUniqueDataFromCache(viewState, HashType.grid)?.tree || [];
  const configLoaded = !viewState.isConfigLoading;
  const gridDataLoaded = isDataLoaded(macroDataState);
  const macroDataLoaded = isDataLoaded(gridDataState);
  const dataLoaded = gridDataLoaded && macroDataLoaded;
  const viewDataState = [macroDataState, gridDataState];

  return {
    title,
    configLoaded,
    gridDataLoaded,
    macroDataLoaded,
    dataLoaded,
    subheaderState: state.subheader,
    macroData,
    gridData,
    viewDefns,
    viewDataState,
  };
}

export const selectData = createSelector(selectState, projectState);
